export function isRawRendering(rendering) {
    return !rendering.componentName && rendering.name !== undefined;
}
